$( document ).ajaxError(function(event, jqxhr, settings, thrownError) {
  switch(jqxhr.status)
  {
  case 401:
      control.auth_info = null;

      if(settings.alert || document.auth_required)
      {
        control.loginRequiredAlert();
      }else if($.isFunction(settings.OnUnauth))
      {
        settings.OnUnauth.call(this, event, jqxhr, settings, thrownError);
      }
    break;
  default:
    sweetAlert("Oops...", "Server has failed process your request, please contact administrator to report this error.", "error");
  }
});

var control = 
    {
      constants:
      {
        tmp_login_status: '<div class="login-status-box tm-float">' +
        '<div class="tm-float tm-block-users tm-users-success tm-caret-down">' +
        '<a href="#"><%= email %></a>' +
        '<i class="fa fa-caret-down tm-caret-down-color"></i>' +
        '<div class="tm-item-box">' +
        '<ul>' +
        '<li><a href="/pages/account-profile?type=email">Change Email</a></li>' +
        '<li><a href="/pages/account-profile?type=pws">Change Password</a></li>' +
        '</ul>' +
        '</div>' +
        '</div>' +
        '<div class="tm-float tm-users-off">' +
        '<a id="btn_logout" href="javascript:void(0);" class="tm-out"><i class="glyphicon glyphicon-off"></i></a>' +
        '</div>' +
        '</div>',
        tmp_login_status_unauth: '<div class="tm-float tm-block-users"><a href="<%=url%>"><i class="tm-users fa fa-user"></i></a></div>',
        webapi_url: "https://otium-web-api.templus.cn",
        cookie_rememberme: "otium.login.rememberme",
        cookie_auth_token: "otium.auth.token"
      },
      getQueryString: function (){

        var result = location.search.match(new RegExp("[\?\&][^\?\&]+=[^\?\&]+","g")); 

        if(result == null){
          return "";
        }

        for(var i = 0; i < result.length; i++){

          result[i] = result[i].substring(1);
        }

        return result;
      },

      //根据QueryString参数名称获取值

      getQueryStringByName: function (name){
        var result = location.search.match(new RegExp("[\?\&]" + name+ "=([^\&]+)","i"));

        if(result == null || result.length < 1){
          return "";
        }

        return result[1];

      },

      //根据QueryString参数索引获取值

      getQueryStringByIndex: function (index){
        if(index == null){
          return "";
        }

        var queryStringList = getQueryString();

        if (index >= queryStringList.length){
          return "";
        }

        var result = queryStringList[index];

        var startIndex = result.indexOf("=") + 1;

        result = result.substring(startIndex);

        return result;

      },

      ajaxAuth: function(url, settings)
      {
        var token = Cookies.get(control.constants.cookie_auth_token);

        var newSettings = $.extend({},  
                                   {
          dataType:"json",
          alert: false,
          headers:
          {
            token: token
          }
        }, settings);
        return $.ajax(url, newSettings);
      },

      ajaxFormAuth: function(form, settings)
      {
        var token = Cookies.get(control.constants.cookie_auth_token);

        var newSettings = $.extend({},  
                                   {
          dataType:"json",
          alert: false,
          headers:
          {
            token: token
          }
        }, settings);
        return $(form).ajaxSubmit(newSettings);
      },

      refreshLoginStatus: function(settings)
      {
        var me = this;
        var newSettings = $.extend({},
                                   {
          method: "post",

          success:function(data)
          {
            control.auth_info = data.result;
            var html = _.template(me.constants.tmp_login_status)({
              email: data.result.email
            });

            $("#login_status").html(html);
          },
          OnUnauth: function(event, jqxhr, settings, thrownError)
          {
            var loginUrl = me.loginUrl();
            $("#login_status").html(_.template(me.constants.tmp_login_status_unauth)({url: loginUrl}));
          }
        }, settings);

        this.ajaxAuth(this.constants.webapi_url + '/advanced/getUser',newSettings);
      },

      isLoggedin: function()
      {
        return control.auth_info ? true : false;
      },
      updateUrlParameter: function(uri, key, value) {
        // remove the hash part before operating on the uri
        var i = uri.indexOf('#');
        var hash = i === -1 ? ''  : uri.substr(i);
        uri = i === -1 ? uri : uri.substr(0, i);

        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";

        if (!value) {
          // remove key-value pair if value is empty
          uri = uri.replace(new RegExp("([?&]?)" + key + "=[^&]*", "i"), '');
          if (uri.slice(-1) === '?') {
            uri = uri.slice(0, -1);
          }
          // replace first occurrence of & by ? if no ? is present
          if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
        } else if (uri.match(re)) {
          uri = uri.replace(re, '$1' + key + "=" + value + '$2');
        } else {
          uri = uri + separator + key + "=" + value;
        }
        return uri + hash;
      },
      loginUrl: function(redirectTo)
      {
        var url = "/account/login";
                
        if(url == window.location.pathname)
        {
          url = window.location.href;
        }
        else
        {
          var redirect = redirectTo;
          if(!redirect)
          {
            if(typeof loginredirect != 'undefined' && loginredirect)
            {
              redirect = loginredirect;
            }
            else
            {
              redirect = window.location.pathname;
              if(window.location.search)
              {
                redirect += this.updateUrlParameter(window.location.search, "redirect");
              }
            }
          }

          url = url + "?redirect=" + encodeURIComponent(redirect);
        }

        return url;
      },
      redirectLogin: function(redirectTo)
      {
        var url = this.loginUrl(redirectTo);

        window.location = url;
      },
      hasScrollbar: function()
      {
        // The Modern solution
        if (typeof window.innerWidth === 'number')
          return window.innerWidth > document.documentElement.clientWidth

        // rootElem for quirksmode
        var rootElem = document.documentElement || document.body

        // Check overflow style property on body for fauxscrollbars
        var overflowStyle

        if (typeof rootElem.currentStyle !== 'undefined')
          overflowStyle = rootElem.currentStyle.overflow

        overflowStyle = overflowStyle || window.getComputedStyle(rootElem, '').overflow

          // Also need to check the Y axis overflow
        var overflowYStyle

        if (typeof rootElem.currentStyle !== 'undefined')
          overflowYStyle = rootElem.currentStyle.overflowY

        overflowYStyle = overflowYStyle || window.getComputedStyle(rootElem, '').overflowY

        var contentOverflows = rootElem.scrollHeight > rootElem.clientHeight
        var overflowShown    = /^(visible|auto)$/.test(overflowStyle) || /^(visible|auto)$/.test(overflowYStyle)
        var alwaysShowScroll = overflowStyle === 'scroll' || overflowYStyle === 'scroll'

        return (contentOverflows && overflowShown) || (alwaysShowScroll);
      },
      loginRequiredAlert: function(settings)
      {
        var me = this;
        var options = $.extend({}, 
        {
          title: "Login required",
          text: "Login is required for taking the action",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Login now",
          closeOnConfirm: false  
        }, settings);

        swal(options, function(){
          me.redirectLogin(settings ? settings.redirectURL : "");
        });
      }
    };

var ly =
    {
      block:function(dom,w){
        var w = w || 100;
        $(dom).addClass("loading");

        var _html = "";
        _html +='<div class="modal-backdrop in"></div>';
        _html +='<div class="modal-loading" id="myModal" role="dialog" >';
        _html +='<div class="modal-dialog my-modal-dialog">';
        _html +='<div class="loadImg"></div>';
        _html +='</div>';
        _html +='</div>';
        $(dom).append(_html);

        $(".loadImg").css({
          "background-size":w+"px",
          "-webkit-background-size":w+"px",
          "-ms-background-size":w+"px",
          "-moz-background-size":w+"px"
        });
      },
      close:function(dom){
        $(".modal-backdrop,.modal-loading").remove();
        $(dom).removeClass("loading");
      }
    };

$(function()
{
  $("#form-subscribe").validate({
    rules:
    {
      email: {
        required: true,
        email: true
      }
    },
    messages:
    {
      email: 
      {
        required: "Please enter your email address",
        email: "Please enter a valid email address"
      }
    },
    errorPlacement: function(error, element)
    {

    },
    highlight: function(element, errorClass)
    {
      $(element).css({boxShadow: "0 0 3px 0 #f10606"});
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).css({boxShadow: "none"});
    },
    submitHandler: function(form) {
      $(form).ajaxSubmit({
        dataType:"json",
        beforeSend:function(){
          $(":submit", form).button('loading');
        },
        success:function(data){
          swal('Subscribed','You have successfully enrolled to Otium news letter service!','success');
        },
        complete: function(xhr, textStatus)
        {
          $(":submit", form).button('reset');
        }
      });
	    }
	});
  
  $(".form-search").each(function(i, form)
  {
    $(form).validate({
      rules:
      {
        q: {
          required: true
        }
      },
      messages:
      {
        q: 
        {
          required: "Please enter your search term"
        }
      },
      errorPlacement: function(error, element)
      {

      },
      highlight: function(element, errorClass)
      {
        $(element).parent().css({borderColor: "#a94442"});
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).parent().css({borderColor: ""});
      }
    });
  });
});